/**
 * TanStack Router: /performance/individual
 *
 * This route file was auto-generated by the route generation script.
 * Component: PerformanceIndividualPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import PerformanceIndividualPage from '@/app/performance/individual/page'

/**
 * Route: /performance/individual
 * Layout: _auth (authenticated)
 * Component: PerformanceIndividualPage
 */
export const Route = createFileRoute('/_auth/performance/individual')({
  component: PerformanceIndividualPage,
})
